<div class="dashboard-container" *ngIf="!loading; else loadingState">
  <h5 class="dashboard-title">Dashboard</h5>
  <div class="dashboard-content">

    <!-- Left Cards -->
    <div class="left-cards">
      <div class="card">
        <h5>Total Batches</h5>
        <p>{{ batches.length }}</p>
      </div>
      <!-- <div class="card">
        <h5>Total Users</h5>
        <p>{{ users.length }}</p>
      </div> -->
    <div class="card" *ngIf="userRole === 'StoreAdmin'">
    <h5>Total Users</h5>
    <p>{{ users.length }}</p>
  </div>

  <div class="card" *ngIf="userRole === 'Admin'">
    <h5>Total Stores</h5>
    <p>{{ totalStores }}</p>
  </div>
    </div>

    <!-- Bar Chart -->
    <div class="bar-chart">
      <h5 class="daily">Daily Activity Report</h5>
      <canvas baseChart
        [data]="{
          labels: barChartLabels,
          datasets: [{ label: 'Batches Posted', data: barChartData, backgroundColor: 'rgba(54, 162, 235, 0.5)' }]
        }"
        [type]="barChartType">
      </canvas>
    </div>

    <!-- Doughnut Chart -->
    <div class="chart-container">
      <canvas baseChart
        [data]="{
          labels: doughnutChartLabels,
          datasets: [{ 
            data: doughnutChartData, 
            backgroundColor: doughnutChartColors, 
            hoverBackgroundColor: doughnutChartColors 
          }]
        }"
        [type]="doughnutChartType"
        [options]="chartOptions">
      </canvas>
    </div>
    

    <!-- In-Progress Batch List -->
    <div id="mySidepanel" class="sidepanel" [style.width]="showInProgressList ? '450px' : '0'">
      <a href="javascript:void(0)" class="closebtn" (click)="closeNav()">×</a>
      <h4 style="color: white;" align="center">In-Progress Batches</h4>

      <div *ngIf="getInProgressList().length > 0; else noBatches" class="batch-list">
        <table class="batch-table">
          <thead>
            <tr>
              <th>User Detail</th>
              <th>Status</th>
              <th>Creation Date</th>
              <th>Detail</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let batch of getInProgressList()">
              <td>
                <div *ngIf="userNameMap[batch.userName]; else noMap">
                  <div>{{ userNameMap[batch.userName].split(',')[0] }}</div>
                  <small>{{ userNameMap[batch.userName].split(',').slice(1).join(' ') }}</small>
                </div>
                <ng-template #noMap>
                  <div>{{ batch.userName }}</div>
                </ng-template>
              </td>
              <td>{{ batch.status }}</td>
              <td>
                {{ batch.createdAt | date: 'medium' }}
                <b *ngIf="batch.status == 'Pending'">{{ calculatePendingTime(batch.createdAt) }}</b>
              </td>
              <td>
                <div>Prescriptions: <strong>{{ batch.prescriptions.length }}</strong></div>
                <div>Medications: <strong>{{ getMedicationCount(batch) }}</strong></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #noBatches>
        <p class="no-batches">No batch found.</p>
      </ng-template>
    </div>
  </div>  
</div>

<!-- Loading State -->
<ng-template #loadingState>
  <div class="loading">
    <div class="scanner-container">
      <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100"
        class="bi bi-upc-scan me-2 scanner-icon" viewBox="0 0 16 16">
        <path
          d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5M.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5M3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0z" />
      </svg>
      <div class="scanner-line"></div>
    </div>
  </div>
</ng-template>


<!-- Toggle Button -->
<button class="openbtn" *ngIf="!showInProgressList" (click)="openNav()">◀</button>
